import { render } from "./index_tiny.vue?vue&type=template&id=7ddfee4e&scoped=true"
import script from "./index_tiny.vue?vue&type=script&lang=js"
export * from "./index_tiny.vue?vue&type=script&lang=js"

import "./index_tiny.vue?vue&type=style&index=0&id=7ddfee4e&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddfee4e"]])

export default __exports__